import {createContext} from '@lit/context';

export type Artist = {
  loading?: boolean,
  data?: any,
  view?: string
};

export const artistContext = createContext<Artist>(Symbol('data'));